export default {
    ["LOAD_FINANCIERS"]: (state, financiers) => {
        state.financiers = financiers;
    },
    ["DELETE_FINANCIER"]: (state, financierId) => {
        state.financiers = state.financiers.filter((e) => e._id != financierId);
    },
    ["ADD_FINANCIER"]: (state, newFinancier) => {
        state.financiers.push(newFinancier);
    },
    ["UPDATE_FINANCIER"]: (state, updatedFinancier) => {
        const financierIndexInState = state.financiers.findIndex((e) => e._id === updatedFinancier._id);
        state.financiers[financierIndexInState] = updatedFinancier;
    },
    ["SET_FINANCIER_ID"]: (state, financierId) => {
        state.financierId = financierId;
    }
};
